import React, { Component } from 'react';
import { Container } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import DocTable from "./DocTable";
import ShowCode from "./ShowCode";
import { request } from "../../helper/APIUtils";
import ReactDOM from "react-dom";
import ReactLoadingTop from "../../components/ReactLoadingTop";

class SectionDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenDetail: true,
            documentation: [],
            previousEndpointId: 0,
            loading:true
        }
        this.showingDetail = this.showingDetail.bind(this);
    }

    showingDetail(value) {
        let self = this;
        self.setState({ isOpenDetail: value });
    }
    componentDidMount() {
        if(this.props.endpointId!=null)
            this.getEndpointById(this.props.endpointId);
        else
            this.getEndpointById(1);
    }
    componentDidUpdate(prevProps) {
        if(this.props.endpointId!=prevProps.endpointId){
            this.getEndpointById(this.props.endpointId);
        }
    }
    componentWillUnmount() {
        this.props.updateEndpoint(1)
    }
    getEndpointById(id) {
        let self = this;
        self.setState({ loading: true })

        if (self.state.previousEndpointId != id && id != null) {
            let params = {
                url: "/servicedocumentation/get?id=" + id,
                method: "get"
            };
            request(params)
                .then(function (response) {
                    self.setState({ documentation: response.data });
                    self.setState({ loading: false })
                });
            self.setState({ previousEndpointId: id });
            self.setState({ isOpenDetail: true });
        }
    }

    render() {
        const ParametersHeaders = [
            { name: 'Parametre', accessor: 'name' },
            { name: 'Tipi', accessor: 'type' },
            { name: 'Açıklama', accessor: 'explanation' }
        ]
        const ResponseCodeHeaders = [
            { name: 'Kod', accessor: 'code' },
            { name: 'Mesaj', accessor: 'message' },
            { name: 'Açıklama', accessor: 'explanation' },
            { name: 'Örnek', accessor: 'example' }
        ]
        return (
            <Container fluid>
                {this.state.loading &&
                    <div className="loader-container">
                        <div className="sk-cube-grid">
                            <div className="sk-cube sk-cube1"></div>
                            <div className="sk-cube sk-cube2"></div>
                            <div className="sk-cube sk-cube3"></div>
                            <div className="sk-cube sk-cube4"></div>
                            <div className="sk-cube sk-cube5"></div>
                            <div className="sk-cube sk-cube6"></div>
                            <div className="sk-cube sk-cube7"></div>
                            <div className="sk-cube sk-cube8"></div>
                            <div className="sk-cube sk-cube9"></div>
                        </div>
                    </div>
                }{this.props.endpointId == 1 &&
                <div className="alert alert-danger" style={{fontSize:"14px",marginTop:"10px"}} role="alert">
                    Lütfen sol taraftan bir doküman seçiniz!</div>
                }
                {this.props.endpointId != 1 && this.state.isOpenDetail &&
                    <Row>
                        <Col md="12" className="sdBaseBackground" style={{paddingTop: "15px"}}>
                                <div><h4 className="sdHeader"> {this.state.documentation.name} </h4></div>
                                <div><p className="sdParagraph "> {this.state.documentation.explanation} </p></div>
                                {this.state.documentation.parameters != null && this.state.documentation.parameters.length != 0 &&
                                        <div>
                                            <div><h5 className="sdSubHeader">Parametreler</h5></div>
                                            <div style={{marginLeft: "-50px", marginTop: "20px "}}>
                                                <DocTable headers={ParametersHeaders}
                                                          data={this.state.documentation.parameters}/>
                                            </div>
                                        </div>}
                                    {this.state.documentation['returnValue'] &&
                                        <div style={{marginBottom: "20px"}}>
                                            <div><h5 className="sdSubHeader"> Dönüş Değeri </h5></div>
                                            <div><p className="sdParagraph"> {this.state.documentation.returnValue} </p>
                                            </div>
                                        </div>}
                                    {this.state.documentation.responsecodes != null && this.state.documentation.responsecodes.length != 0 &&
                                        <div>
                                            <div><h5 className="sdSubHeader"> Hata Kodları</h5></div>
                                            <div style={{marginLeft: "-50px"}}>
                                                <DocTable headers={ResponseCodeHeaders}
                                                          data={this.state.documentation.responsecodes}/>
                                            </div>
                                        </div>}
                                </Col>
                        <Col md={"12"} className="sdBaseBackground ">
                            <ShowCode code={this.state.documentation.code}
                                      method={this.state.documentation.method}
                                      url={this.state.documentation.url}
                                      isOpenDetail={this.state.isOpenDetail}
                                      listener={this.showingDetail}/>
                        </Col>
                    </Row>
                }

            </Container>
        );
    }
}

export default SectionDetail;